import { Form, Input } from "decorator-form";

import { IFileUpload } from "common/form/fields/upload/UploadField";
import InputType from "common/form/InputType";
import ContainerLink from "common/views/menuTree/linkTypes/ContainerLink";
import LanguageOption from "common/views/menuTree/linkTypes/LanguageOption";
import PageLink from "common/views/menuTree/linkTypes/PageLink";
import SignInOutLink from "common/views/menuTree/linkTypes/SignInOutLink";
import StaticLink from "common/views/menuTree/linkTypes/StaticLink";
import WelcomeContainerLink from "common/views/menuTree/linkTypes/WelcomeContainerLink";
import INavMenuConfig from "common/views/menuTree/NavMenuConfig";
import { NavMenuField } from "common/views/menuTree/NavMenuField";

const menuInput = NavMenuField.registerWithTypes([
	PageLink,
	StaticLink,
	ContainerLink,
	SignInOutLink,
	LanguageOption,
	WelcomeContainerLink
]);

@Form({title: "Header Config"})
export default class HeaderConfig {

	// Logo

	@Input({type: InputType.TEXT, title: "Logo URL"})
	public logoUrl: string;

	@Input({type: InputType.UPLOAD, title: "Logo", description: "(This won't do anything yet, just trying it out)"})
	public logo: IFileUpload;

	@Input({type: InputType.TEXT, title: "Logo Link"})
	public logoLink: string;

	@Input({type: InputType.UNIT, title: "Logo Width"})
	public logoWidth?: string;

	@Input({type: InputType.CHECKBOX, title: "Open in New Tab"})
	public openInNewTab: boolean = false;

	@Input({type: menuInput, title: "Toolbar"})
	public toolbar: INavMenuConfig;

}



// WEBPACK FOOTER //
// ./src/panels/header/HeaderConfig.ts